import { Component } from '@angular/core';
import { LoadingSpinnerService } from './loading-spinner.service';
import { of } from 'rxjs';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-loading-spinner',
    templateUrl: './loading-spinner.component.html',
    styleUrls: ['./loading-spinner.component.scss'],
    imports: [AsyncPipe]
})
export class LoadingSpinnerComponent {

    public isActive$ = of(true);

    constructor(private spinnerService: LoadingSpinnerService) {
        this.isActive$ = this.spinnerService.spinnerControl$;
    }
}
